let counter = 0;

/** Short, URL-safe, collision-resistant enough for collaborative documents. */
export function newId(prefix = "id"): string {
  const c = typeof globalThis !== "undefined" ? (globalThis.crypto as Crypto | undefined) : undefined;
  let random: string;
  if (c && typeof c.randomUUID === "function") {
    random = c.randomUUID().replace(/-/g, "").slice(0, 12);
  } else if (c && typeof c.getRandomValues === "function") {
    const bytes = new Uint8Array(8);
    c.getRandomValues(bytes);
    random = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  } else {
    random = Math.random().toString(36).slice(2, 14);
  }
  counter = (counter + 1) % 1296;
  return `${prefix}_${Date.now().toString(36)}${counter.toString(36)}${random}`;
}

export function newBlockId(): string {
  return newId("blk");
}

export function shortId(id: string): string {
  return id.length > 10 ? id.slice(-8) : id;
}
